import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-input',
  template: `
    <label class="formly-repeat-input-label" *ngIf="to.label">{{ to.label }}</label>
    <div *ngFor="let field of field.fieldGroup; let i = index;" class="row formly-repeat-input-row">
      <formly-field class="col" [field]="field"></formly-field>
      <div class="mat-form-field-wrapper col-sm-1 tw-flex align-items-center tw-cursor-pointer formly-repeat-input-remove-button"
           *ngIf="i > 0 || to.allRemovable"
           (click)="remove(i)"
      >
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <div class="tw-pb-6 repeat-input-add-button-container">
      <button tabindex="999" mat-stroked-button color="primary" class="tw-bg-white repeat-input-add-button" type="button" (click)="add()">
        <mat-icon>add</mat-icon>
        <span>{{ to.addText }}</span>
      </button>
    </div>
  `,
  styles: [
    `.formly-repeat-input-label {
      margin-bottom: .25rem;
    }`,
    `.repeat-input-add-button mat-icon {
      height: 18px;
      width: 18px;
      line-height: 18px;
    }`
  ]
})
export class FormlyRepeatInputComponent extends FieldArrayType {}
